<div class="container-1 code-component">
  <div class="container-2">
    <div class="mb-2 patterns">
      <div class="row">
        @if(model.helpVisible()){
        <div class="help-text ml-0">
            При вводе в поле camelCase преобразуется в поле kebab-case и наоборот.
        </div>
        }
        <input [(ngModel)]="nameCamel" placeholder="camelCase" (keyup)="nameCamelKeyup()" type="text" class="inp-1" id="nameCamel" />
        <button class="btn-1 one" (click)="Utilits.copy(nameCamel)" [title]="text.of('Copy')">C</button>
        <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, nameCamel)" title="Добавить в Палитра копипаста временная">P</button>
        <button class="btn-1 one" (click)="nameCamel='';Utilits.focus('nameCamel');" title="Очистка и фокус">F</button>
      </div>
      <div class="row">
        <input [(ngModel)]="nameKebab" placeholder="kebab-case" (keyup)="nameKebabKeyup()" type="text" class="inp-1" />
        <button class="btn-1 one" (click)="Utilits.copy(nameKebab)" [title]="text.of('Copy')">C</button>
        <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, nameKebab)" title="Добавить в Палитра копипаста временная">P</button>
        <button class="btn-1 one" (click)="nameKebab='';Utilits.focus('nameKebab');" title="Очистка и фокус">F</button>
      </div>

    <div (click)="blockTextReplacingPatternsVis=!blockTextReplacingPatternsVis" class="h mb-1 ml-0 cur-pointer">Подстановки</div>
    @if(model.helpVisible()){
      <div class="help-text ml-0">
          Подставляется текст из полей выше в определенном формате, например, "..camelFirstLower.." заменяется на текст первого поля с первой буквой переведенной в нижний регистр.
          Конфигурацию можно задать в настройках.
      </div>
    }
    @if(blockTextReplacingPatternsVis){
    @for (p of model.patterns(); track p; let i = $index) {
      <div class="row nowrap">
        <div class="content">
          <span>{{processPattern(p)}}</span>
          <button class="btn-1 one" (click)="Utilits.copy(processPattern(p))" [title]="text.of('Copy')">C</button>
          <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, processPattern(p))" title="Добавить в Палитра копипаста временная">P</button>
        </div>
      </div>
    }
    }

  </div>
    <div>
      <app-replacing></app-replacing>
    </div>
</div>
<div class="container-3">
  <div>
    <div class="h ml-1">Палитра копипаста временная</div>
    @if(model.helpVisible()){
    <div class="help-text ml-1">
Поля для хранения временных данных для копипаста. При заполнении одного поля появляется новое (при выходе курсора). Сохраняются в localStorage браузера.
Удобное копирование в буфер по кнопке C.
    </div>
    }
    <div class="palette-items-container">
    @for (p of model.copypasteTempPalette(); track p; let i = $index) {
      <div class="row">
        <div class="buttons">
          <button class="btn-1 one left" (click)="Utilits.copy(p.value)" [title]="text.of('Copy')">C</button>
          <button class="btn-1 one left" (click)="p.value='';Utilits.focus('pal'+i);" title="Очистка и фокус">F</button>
        </div>
        <textarea [(ngModel)]="p.value" [id]="'pal'+i" class="textarea-1" rows="5" (blur)="act.do(Actions.copypasteTempPaletteSave)"></textarea>
      </div>
    }
    </div>
  </div>
  @if(model.auth()){
  <div>
    <div class="h mb-1">Палитра копипаста</div>
    <div>
    @for (p of model.copypastePalette; track p; let i = $index) {
      <div class="row">
        <div class="buttons">
          <button class="btn-1 one left" (click)="Utilits.copy(p.value)" [title]="text.of('Copy')">C</button>
          <button class="btn-1 one left" (click)="p.value='';Utilits.focus('pal'+i);" title="Очистка и фокус">F</button>
          <input type="checkbox" [(ngModel)]="p.isPattern" (change)="act.do(Actions.copypastePaletteSave)" />
        </div>
        <textarea [(ngModel)]="p.value" [id]="'pal'+i" class="textarea-1" rows="5" (blur)="act.do(Actions.copypastePaletteSave)"></textarea>
      </div>
    }
    </div>
  </div>
}
</div>
</div>